/**
 * Send message to parent window, possibly container of an iframe that is currently wrapping our Application
 *
 * @param message - The message to send
 * @param targetOrigin - The target origin for the message
 */
export const sendMessageToParent = (message: unknown, targetOrigin: string = '*'): void => {
  if (!window.parent) {
    return;
  }

  window.parent.postMessage(message, targetOrigin);
};

/**
 * Subscribe for browser messages from other windows
 *
 * @param listener - The message event listener
 * @returns Unsubscribe callback
 */
export const subscribeToMessages = (listener: (event: MessageEvent) => void): (() => void) => {
  window.addEventListener('message', listener);
  return () => {
    window.removeEventListener('message', listener);
  };
};
